import { render, staticRenderFns } from "./ques-radio-gender.vue?vue&type=template&id=26f9a040&scoped=true&"
import script from "./ques-radio-gender.vue?vue&type=script&lang=js&"
export * from "./ques-radio-gender.vue?vue&type=script&lang=js&"
import style0 from "./ques-radio-gender.vue?vue&type=style&index=0&id=26f9a040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f9a040",
  null
  
)

export default component.exports